function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00893F;fill-opacity:0.25;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#303231;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#303231;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Group 24");

var _ref4 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "HFP-"
}, React.createElement("g", {
  transform: "translate(-239.000000, -225.000000)"
}, React.createElement("g", {
  id: "Group-53",
  transform: "translate(48.000000, 130.000000)"
}, React.createElement("g", {
  id: "Group-52"
}, React.createElement("g", {
  id: "Group-31",
  transform: "translate(0.000000, 0.126556)"
}, React.createElement("g", {
  id: "Group-24",
  transform: "translate(191.000000, 94.873444)"
}, React.createElement("g", {
  id: "Group-23"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(52.821605, 20.404345)"
}, React.createElement("path", {
  id: "Fill-1",
  className: "st0",
  d: "M222.1,0h-4.9c-0.6,0-1.2,0.5-1.2,1.2v1.6c0,0.6,0.5,1.2,1.2,1.2h4.9 c0.6,0,1.2-0.5,1.2-1.2V1.2C223.3,0.5,222.8,0,222.1,0"
}), React.createElement("path", {
  id: "Fill-3",
  className: "st0",
  d: "M249.1,0h-4.9c-0.6,0-1.2,0.5-1.2,1.2v1.6c0,0.6,0.5,1.2,1.2,1.2h4.9 c0.6,0,1.2-0.5,1.2-1.2V1.2C250.2,0.5,249.7,0,249.1,0"
})), React.createElement("path", {
  id: "Fill-6",
  className: "st0",
  d: "M219.7,29.3h3.9c1.8,0,3.1-1,3.7-1.6c1.5-1.6,1.3-3.9,1.3-4.3l0-5.2h-1.9l-1.8,6.9l-5,2.6 L219.7,29.3z"
}), React.createElement("path", {
  id: "Fill-8",
  className: "st1",
  d: "M301.3,39.7c0,0.5-0.4,1-1,1s-1-0.4-1-1c0-0.5,0.4-1,1-1S301.3,39.2,301.3,39.7 M300.4,34.9 c-2.7,0-4.9,2.2-4.9,4.8c0,2.7,2.2,4.8,4.9,4.8c2.7,0,4.9-2.2,4.9-4.8C305.2,37,303,34.9,300.4,34.9"
}), React.createElement("path", {
  id: "Fill-10",
  className: "st1",
  d: "M240.4,39.7c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1 C240,38.8,240.4,39.2,240.4,39.7 M239.5,34.9c-2.7,0-4.9,2.2-4.9,4.8c0,2.7,2.2,4.8,4.9,4.8c2.7,0,4.9-2.2,4.9-4.8 C244.3,37,242.2,34.9,239.5,34.9"
}), React.createElement("path", {
  id: "Fill-12",
  className: "st1",
  d: "M269.1,19.4c-0.6,0-1.2,0.5-1.2,1.2v1.6c0,0.6,0.5,1.2,1.2,1.2h4.9c0.6,0,1.2-0.5,1.2-1.2 v-1.6c0-0.6-0.5-1.2-1.2-1.2H269.1z"
}), React.createElement("path", {
  id: "Fill-14",
  className: "st1",
  d: "M296.1,19.4c-0.6,0-1.2,0.5-1.2,1.2v1.6c0,0.6,0.5,1.2,1.2,1.2h4.9c0.6,0,1.2-0.5,1.2-1.2 v-1.6c0-0.6-0.5-1.2-1.2-1.2H296.1z"
}), React.createElement("g", {
  id: "Group-18",
  transform: "translate(0.000000, 0.254345)"
}, React.createElement("g", {
  id: "Clip-17"
}), React.createElement("defs", null, React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 216,
  y: 0.2,
  width: 104.7,
  height: 50.3
}, React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 216,
  y: 0.2,
  width: 104.7,
  height: 50.3,
  id: "mask-2_1_"
}, React.createElement("g", {
  className: "st1"
}, React.createElement("polygon", {
  id: "path-1_1_",
  className: "st3",
  points: "216,0.2 320.7,0.2 320.7,50.5 216,50.5  "
}))), React.createElement("path", {
  id: "Fill-16",
  className: "st4",
  d: "M316.8,34c0,0.5-0.2,4.8-3,4.8h-2c-0.1,0-0.3-0.1-0.5-0.2c-0.5-5.7-5.3-10.1-11-10.1 c-4.2,0-8,2.4-9.9,6.2h-41.1c-1.9-3.8-5.7-6.2-9.9-6.2c-5.7,0-10.5,4.4-11,10.1c-0.2,0.1-0.3,0.2-0.5,0.2h-6.4 c-0.3,0-0.6-0.2-0.7-0.5l-0.7-2c-0.1-0.4-0.2-1-0.2-1.4v-7.2h2.6c1.8,0,2.9-0.8,3.5-1.5c1.5-1.6,1.3-3.9,1.3-4.3l0-4 c1-0.1,1.9-0.2,3-0.2h18.3c0.2,0,0.4,0,0.6-0.1c0.6,1.5,2,2.6,3.7,2.6h2.8c1.7,0,3.1-1,3.7-2.5l57.4,0c0,0,0,1.1,0,1.4h-4.6 c-0.6,0-1.2,0.5-1.2,1.2v11.8c0,0.6,0.5,1.2,1.2,1.2h4.6L316.8,34z M307.5,39.5c0,0.3,0,0.5-0.1,0.7l-0.1,0.8 c-0.7,3.2-3.7,5.6-7,5.6c-3.3,0-6.2-2.3-7-5.6l-0.1-0.8c0-0.3-0.1-0.5-0.1-0.8c0-3.9,3.2-7.1,7.2-7.1 C304.3,32.3,307.5,35.5,307.5,39.5L307.5,39.5z M289.8,38.8c-0.2,0.2-0.5,0.4-0.8,0.4h-38c-0.3,0-0.6-0.2-0.8-0.4 c0-0.2,0-0.4-0.1-0.6h39.8C289.8,38.3,289.8,38.5,289.8,38.8L289.8,38.8z M246.6,40.2l-0.1,0.8c-0.7,3.2-3.7,5.6-7,5.6 c-3.3,0-6.2-2.3-7-5.6l-0.1-0.7c0-0.3-0.1-0.6-0.1-0.8c0-3.9,3.2-7.1,7.2-7.1c1.4,0,2.8,0.4,4,1.2c2,1.3,3.2,3.5,3.2,5.9 C246.6,39.7,246.6,40,246.6,40.2L246.6,40.2z M219.9,22.8c0.2-0.6,0.8-2.4,3.5-3.7v3.1c0,0.6,0,1.3-0.3,1.5 c0,0-0.1,0.2-0.6,0.2h-2.6V22.8z M252.8,15.2C252.8,15.2,252.8,15.2,252.8,15.2h2.9l-0.1,1.1l-2.9-0.1V15.2z M260.1,4.5 c0.2-0.2,0.6-0.5,1-0.5h16.7v9.8h-18.4c-0.6-1.5-2-2.5-3.7-2.5h-0.9L260.1,4.5z M281.6,4.1h12.6l9.2,9.8h-21.7V4.1z  M302.5,4.1c0.3,0,0.8,0.2,1,0.4l9.2,9.3h-4.1l-9.2-9.8H302.5z M315.3,23.1h1.1c0.2,0,0.4,0.2,0.4,0.4V29 c0,0.2-0.2,0.4-0.4,0.4h-1.1c-0.2,0-0.4-0.2-0.4-0.4v-5.5C314.9,23.2,315.1,23.1,315.3,23.1L315.3,23.1z M320.1,15.7 L305.4,0.9c-0.4-0.4-1.1-0.7-1.6-0.7h-44.3c-0.6,0-1.2,0.3-1.6,0.8L248,13.5c-0.2,0.2-0.7,0.5-1,0.5h-16.8 c-13,0-14.2,8.2-14.3,8.6l0,13c0,0.5,0.1,1.2,0.3,1.6l1.7,4.5c0.2,0.5,0.8,1,1.4,1h9.5c1.4,4.6,5.7,7.8,10.5,7.8 s9.1-3.2,10.5-7.8h39.8c1.4,4.6,5.7,7.8,10.5,7.8c4.8,0,9.1-3.2,10.5-7.8h2.9c5.5,0,6.9-5.8,6.9-8.8V17.3 C320.7,16.8,320.4,16.1,320.1,15.7L320.1,15.7z"
})), React.createElement("path", {
  id: "Fill-19",
  className: "st0",
  d: "M265.3,14.1h-6c-0.6-1.5-2-2.5-3.7-2.5h-0.9l5.4-6.8c0.2-0.2,0.7-0.5,1-0.5h4.3"
}), React.createElement("polyline", {
  id: "Fill-21",
  className: "st0",
  points: "287.8,14.1 281.6,14.1 281.6,4.3 284.9,4.3  "
}))))))));

var SvgCarOnly = function SvgCarOnly(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "340px",
    height: "55px",
    viewBox: "0 0 340 55",
    style: {
      enableBackground: "new 0 0 340 55"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCarOnly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car-only.caca7e5a.svg";
export { ForwardRef as ReactComponent };